import { useEffect } from 'react'
import { Redirect, Switch, Router, Route, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { connect } from 'react-redux'
import { Tabs } from 'antd'
import { useQuery } from 'Hooks'
import { setTab } from 'Actions/explore'
import TreeTabHeader from './TreeTabHeader'
import TreeTabFooter from './TreeTabFooter'
import tabs from './tabs'
import styled from 'styled-components'
import { store } from '~/Store'
{ TabPane } = Tabs
import './index.scss'

LeftPanel = ({ active, setActive, tabsDisabled, width, currentProject }) ->
  { url, params: { spaceId }} = useRouteMatch()
  params = useQuery()
  { hash }  = useLocation()
  history = useHistory()

  useEffect( ->
    if not params.get('tab')
      params.set('tab', 'home')
      history.replace({ pathname: url, search: params.toString(), hash })
    tab = params.get('tab')
    if tabs.find((t) -> t.key is tab)? and active isnt tab and not tabsDisabled[tab]
      setActive(tab)
    undefined
  , [params])

  <>
    <StyledTabs
      activeKey={active}
      animated={{ tabPane: true }}
      renderTabBar={->
        <TreeTabHeader
          tabs={tabs}
          active={active}
          setActive={(next) ->
            setActive(next)
            params.set('tab', next)
            history.push({ pathname: url, search: params.toString(), hash })
          }
          disabledMap={tabsDisabled}
        />
      }
      style={{ flex: '1 1 auto', flexDirection: 'column' }}
      >
        {
          tabs.map(({ key, Component }, i) ->
            <TabPane tab={i} key={key}>
              <Component width={width} />
            </TabPane>
          )
        }
    </StyledTabs>
    <TreeTabFooter width={width} />
  </>

export default connect(({ explore, projects }) ->
  {
    active: explore.currentTab
    tabsDisabled: explore.tabsDisabled
    currentProject: projects.currentProject
  }
, { setActive: setTab }
)(LeftPanel)

StyledTabs = styled(Tabs)"""
  background: var(--bgColor);
""";
